import { render, staticRenderFns } from "./AreaIndicator.vue?vue&type=template&id=1fd08c2f&scoped=true"
import script from "./AreaIndicator.vue?vue&type=script&lang=ts"
export * from "./AreaIndicator.vue?vue&type=script&lang=ts"
import style0 from "./AreaIndicator.vue?vue&type=style&index=0&id=1fd08c2f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd08c2f",
  null
  
)

export default component.exports